import { proxyAsModuleWithBindings } from '../../run/run-helpers.js';

const createFsModule = (rawModule) => {
    const fsExportedNames = rawModule.metadata.compilation.variableNamesIndex.globals.fs;
    const fs = proxyAsModuleWithBindings(rawModule, {
        onReadSoundFile: { type: 'callback', value: () => undefined },
        onWriteSoundFile: { type: 'callback', value: () => undefined },
        onOpenSoundReadStream: { type: 'callback', value: () => undefined },
        onOpenSoundWriteStream: { type: 'callback', value: () => undefined },
        onSoundStreamData: { type: 'callback', value: () => undefined },
        onCloseSoundStream: { type: 'callback', value: () => undefined },
        sendReadSoundFileResponse: {
            type: 'proxy',
            value: 'x_onReadSoundFileResponse' in fsExportedNames
                ? rawModule.globals.fs.x_onReadSoundFileResponse
                : undefined,
        },
        sendWriteSoundFileResponse: {
            type: 'proxy',
            value: 'x_onWriteSoundFileResponse' in fsExportedNames
                ? rawModule.globals.fs.x_onWriteSoundFileResponse
                : undefined,
        },
        // should register the operation success { bitDepth: 32, target: 'javascript' }
        sendSoundStreamData: {
            type: 'proxy',
            value: 'x_onSoundStreamData' in fsExportedNames
                ? rawModule.globals.fs.x_onSoundStreamData
                : undefined,
        },
        closeSoundStream: {
            type: 'proxy',
            value: 'x_onCloseSoundStream' in fsExportedNames
                ? rawModule.globals.fs.x_onCloseSoundStream
                : undefined,
        },
    });
    if ('i_openSoundWriteStream' in fsExportedNames) {
        rawModule.globals.fs.i_openSoundWriteStream = (...args) => fs.onOpenSoundWriteStream(...args);
    }
    if ('i_sendSoundStreamData' in fsExportedNames) {
        rawModule.globals.fs.i_sendSoundStreamData = (...args) => fs.onSoundStreamData(...args);
    }
    if ('i_openSoundReadStream' in fsExportedNames) {
        rawModule.globals.fs.i_openSoundReadStream = (...args) => fs.onOpenSoundReadStream(...args);
    }
    if ('i_closeSoundStream' in fsExportedNames) {
        rawModule.globals.fs.i_closeSoundStream = (...args) => fs.onCloseSoundStream(...args);
    }
    if ('i_writeSoundFile' in fsExportedNames) {
        rawModule.globals.fs.i_writeSoundFile = (...args) => fs.onWriteSoundFile(...args);
    }
    if ('i_readSoundFile' in fsExportedNames) {
        rawModule.globals.fs.i_readSoundFile = (...args) => fs.onReadSoundFile(...args);
    }
    return fs;
};

export { createFsModule };
